import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { InstructionService } from 'src/app/modules/core/services/instruction/instruction.service';

@Component({
    selector: 'app-instruction-by-alias',
    templateUrl: './instruction-by-alias.component.html',
    styleUrls: ['./instruction-by-alias.component.scss']
})
export class InstructionByAliasComponent implements OnInit, OnDestroy {

    @Output() instructionEmitter: EventEmitter<any> = new EventEmitter();

    private destroy$: Subject<void> = new Subject();

    constructor(
        private instructions: InstructionService,
        private route: ActivatedRoute) { }

    ngOnInit() {
        this.route.params
            .pipe(takeUntil(this.destroy$))
            .subscribe(params => {
                this.handleRouteParameterChange(params);
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private handleRouteParameterChange(params: Params) {
        this.instructionEmitter.emit(undefined);

        this.instructions.getInstructionByAlias(`${params.id}/${params.year}`)
            .subscribe(result => {
                result.data['inIframe'] = this.checkIfInIframe();
                this.instructionEmitter.emit(result);
            });
    }

    /**
     * Check if the current page is in an iframe element
     * @return boolean true if in iframe, false otherwise
     */
    public checkIfInIframe(): boolean {
        try {
            return window.self !== window.top;
        }
        catch (e) {
            return true;
        }
    }
}
